const names = [
    {
        name: 'firstAndLast',
        execute: (value) => {
            if (!value || value.indexOf(" ") == 0) {
                return value;
            }
            let name = value.split(" ");
            return `${name[0]} ${name[name.length - 1]}`;
        }
    },
    {
        name: 'initials',
        execute: (value) => {
            if (!value || value.indexOf(" ") == 0) {
                return value;
            }
            let name = value.split(" ");
            return name[0][0] + name[name.length - 1][0];
        }
    },
    {
        name: 'limited',
        execute: (value, limit) => {
            if (value.length > limit) {
                return value.substring(0, limit) + '...';
            } else {
                return value;
            }
        }
    },
    {
        name: 'appBreaklines',
        execute: (value) => {
            return value.replace("/n", '<br />');
        }
    },
    {
        name: 'toDate',
        execute: (value) => {
            const data = new Date(value);
            if (isNaN(data.getTime())) {
                throw new Error('Data inválida');
            }
            return data;
        }
    },
    {
        name: 'getValueTeste',
        execute: (value, array) => {
            console.log('array', array);
            const valoresList = JSON.parse(array, true);
            const valorRealIndex = valoresList.findIndex(
                find => find.id === parseInt(value)
            );
            console.log(valorRealIndex, array);

            /*const valorReal = valorRealIndex !== -1 ? array[valorRealIndex] : null;
            return valorReal;*/
        }
    },
    {
        name: 'dateString',
        execute: (dataString, formato) => {
            const data = new Date(dataString);
            if (isNaN(data.getTime())) {
                throw new Error('Data inválida');
            }
            const dia = String(data.getDate()).padStart(2, '0');
            const mes = String(data.getMonth() + 1).padStart(2, '0');
            const ano = data.getFullYear();
            const horas = String(data.getHours()).padStart(2, '0');
            const minutos = String(data.getMinutes()).padStart(2, '0');
            const segundos = String(data.getSeconds()).padStart(2, '0');
            const partes = {
                'dd': dia,
                'mm': mes,
                'yyyy': ano,
                'hh': horas,
                'ii': minutos,
                'ss': segundos
            };
            return formato.replace(/dd|mm|yyyy|hh|ii|ss/g, matched => partes[matched]);
        }
    },
    {
        name: 'horasTotais',
        execute: (horas, multiplicador) => {
            return horas * multiplicador;
        }
    }
];
export default names